// Import react elements
import { useRef } from "react";

// Import css
import "./ImageUploadTile.css";



const ImageUploadTile = ({
  value,
  alt = "Uploaded image",
  uploading = false,
  onFileSelected,
  fromBucketButton,
  emptyText = "No image uploaded",
  maxWidth = "100%",
}) => {

  const fileInputRef = useRef(null);

  const handleOpenFilePicker = () => {

    fileInputRef.current?.click();

  };

  const handleFileChange = (e) => {

    const file = e.target.files?.[0];

    if (file) {

      onFileSelected?.(file);

    }

    // Allow selecting the same file again.
    e.target.value = "";

  };

  return (

    <div className="image-upload-tile" style={{ maxWidth }}>

      <div className="image-upload-tile__preview">

        {value ? <img src={value} alt={alt} /> : <span>{emptyText}</span>}

      </div>

      <div className="image-upload-tile__actions">

        <button
          type="button"
          className="image-upload-tile__btn"
          onClick={handleOpenFilePicker}
          disabled={uploading}
        >

          {uploading ? "Uploading..." : value ? "Replace" : "Upload"}

        </button>

        {fromBucketButton}

      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        className="image-upload-tile__input"
        onChange={handleFileChange}
      />

    </div>

  );
  
};

export default ImageUploadTile;
